export default __webpack_public_path__ + "static/media/WS.14590791.ico";